export default __webpack_public_path__ + "static/media/portadavideoplanificacion8.feb3eb1b.png";